<template>
  <section class="section-wrapp">
  <Breadcrumbs :parameters=breadcrumbs></Breadcrumbs>
  <section class="section-add-station">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="background-shadow">
            <div class="row">
              <div class="col-12">
                <div class="add-station__title">{{(currentUser === null) ? 'Новый Пользователь' : currentUser.fullName}}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 add-station-form">
                <form action="">
                  <div class="add-station-form__block">
                    <div class="row">
                      <div class="col-12 col-md-5 col-lg-4">
                        <div class="input-wr">
                          <label for="station-title">Имя</label>
                          <input type="text" id="station-title" v-model="user.firstname">
                        </div>
                        <div class="input-wr">
                          <label for="station-second">Фамилия</label>
                          <input type="text" id="station-second" v-model="user.lastname">
                        </div>
                        <div class="input-wr">
                          <label for="station-email">Email</label>
                          <input type="text" id="station-email" v-model="user.email">
                        </div>
                        <div class="input-wr checkbox-users">
                          <input type="checkbox" id="allow-to-restrict" v-model="user.allowToRestrict">
                          <label for="allow-to-restrict">Разрешено управление</label>
                        </div>
                        <div class="input-wr">
                          <label for="station-login">Login</label>
                          <input type="text" id="station-login" v-model="user.login">
                        </div>
                        <div v-if="currentUser !== null" class="input-wr checkbox-users">
                          <input type="checkbox" id="password-toggle" v-model="changePassword">
                          <label for="password-toggle">Изменить пароль</label>
                        </div>
                        <div v-if="changePassword === true">
                        <div class="input-wr">
                          <label for="station-pass">Пароль</label>
                          <input type="password" id="station-pass" v-model="user.password">
                        </div>
                        <div class="input-wr">
                          <label for="station-rpass">Повторите пароль</label>
                          <input type="password" id="station-rpass" v-model="user.rpassword">
                        </div>
                        </div>
                      </div>
                      <div  class="col-12 col-md-5 col-lg-4">
                        <div class="user-stations-name input-wr">
                          <span :style="{color: 'black', 'font-size' : '16px', 'font-weight': 'bolder'}">Станции</span>
                        </div>
                        <div class="input-wr checkbox-users" v-for="(stationTitle, stationId) in this.stations" v-bind:key="stationId">
                          <input type="checkbox" :id="'station-' + stationId" :value=stationId v-model="user.stationIds">
                          <label :for="'station-' + stationId">{{stationTitle}}</label>
                        </div>
                      </div>
                      <div v-if="currentUser === null" class="col-12">
                        <div class="calendar-save text-center">
                          <span class="confirm" @click="createUser">создать</span>
                        </div>
                      </div>
                      <div v-else class="col-12">
                        <div class="calendar-save text-center">
                          <span class="confirm" @click="editUser">сохранить</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </section>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import UsersAPI from '@/api/users'

export default {
  name: 'StationSave',
  components: { Breadcrumbs },
  data () {
    return {
      changePassword: false,
      user: {
        firstname: '',
        lastname: '',
        email: '',
        login: '',
        password: '',
        rpassword: '',
        stationIds: [],
        allowToRestrict: false
      }
    }
  },
  mounted () {
    this.getUser()
    this.getUsers()
  },
  computed: {
    currentUser () {
      return this.$store.getters['users/user']
    },
    stations () {
      return this.$store.getters['users/stations']
    },
    breadcrumbs () {
      return [
        {
          url: '/users',
          title: 'Users'
        },
        {
          url: '#',
          title: 'Edit user'
        }
      ]
    }
  },
  watch: {
    $route: 'getUser'
  },
  methods: {
    getUser () {
      let _this = this

      if (this.$route.name === 'user-edit') {
        let id = this.$route.params.id
        this.$store.dispatch('users/findOne', id)
          .then(() => {
            _this.user = _this.$store.getters[ 'users/user' ]
            _this.user.stationIds = _this.user.stations
          })
        this.changePassword = false
      } else {
        this.changePassword = true
      }
    },
    getUsers () {
      this.$store.dispatch('users/findAll')
    },
    checkPassword () {
      if (this.user.password !== this.user.rpassword) {
        this.$notify({
          group: 'foo',
          title: 'Пароли не совпадают!',
          text: 'Поле пароль и повторить пароль должны совпадать'
        })
        return false
      }
      return true
    },
    createUser () {
      if (!this.checkPassword()) { return }
      let currentObj = this
      UsersAPI.create({
        'firstname': this.user.firstname,
        'lastname': this.user.lastname,
        'password': this.user.password,
        'repeatPassword': this.user.rpassword,
        'email': this.user.email,
        'login': this.user.login,
        'stations': this.user.stationIds,
        'allowToRestrict': this.user.allowToRestrict
      })
        .then((response) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Пользователь создан'
          })
          currentObj.$router.push('/user-edit/' + response.data)
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    },
    editUser () {
      if (this.changePassword) {
        if (!this.checkPassword()) { return }
      } else {
        this.user.password = ''
      }
      let currentObj = this
      UsersAPI.edit(this.$route.params.id, {
        'firstname': this.user.firstname,
        'lastname': this.user.lastname,
        'newPassword': this.user.password,
        'email': this.user.email,
        'login': this.user.login,
        'stations': this.user.stationIds,
        'allowToRestrict': this.user.allowToRestrict
      })
        .then(() => {
          currentObj.$notify({
            group: 'foo',
            title: 'Успех',
            text: 'Пользователь сохранен'
          })
        })
        .catch((error) => {
          currentObj.$notify({
            group: 'foo',
            title: 'Ошибка!',
            text: error
          })
        })
    }
  }
}
</script>
